import { TRACKERS_SHEET_OPEN, TRACKERS_SHEET_CLOSE } from './Trackers-actions';

const initialState = {
  data: {},
  isError: false,
  error: null,
  sheet: {
    isOpen: false,
  },
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case TRACKERS_SHEET_OPEN: {
      return { ...initialState, ...{ sheet: { isOpen: action.payload.isOpen } } };
    }

    case TRACKERS_SHEET_CLOSE: {
      return { ...initialState, ...{ sheet: { isOpen: false } } };
    }

    default:
      return state;
  }
};

export default Reducer;
